import { useField } from "formik";

import {
  CheckboxGroup,
  CheckboxGroupProps,
} from "../components/inputs/checkbox/checkbox-group/CheckboxGroup";

export interface CheckboxGroupFormikFieldProps extends CheckboxGroupProps {
  name: string;
}

export function CheckboxGroupFormikField(props: CheckboxGroupFormikFieldProps) {
  const [field, meta, helpers] = useField(props.name);

  return (
    <CheckboxGroup
      name={props.name}
      value={field.value}
      onChange={helpers.setValue}
      label={props.label}
      isDisabled={props.isDisabled}
      isRequired={props.isRequired}
      isInvalid={Boolean(meta.touched && meta.error)}
      errors={meta.touched ? meta.error : undefined}
      children={props.children}
      testID={props.testID}
    />
  );
}
